<template>
  <div>
    <div class="tool-box">
      <div class="tool-icon-box" @click="openShare">
        <img
          class="tool-icon"
          src="@/assets/img/mobile-img/share-icon.png"
          alt=""
        />
        <span>分享</span>
      </div>
      <Hoarding :shareInfo="shareInfo" />
      <!-- <div class="btn-slot" v-if=""> -->
      <slot name="right"></slot>
      <!-- </div> -->
    </div>
    <van-popup
      :lock-scroll="true"
      v-model="sharePopup"
      class="tool-popup"
      round
      position="bottom"
      :close-on-click-overlay="false"
    >
      <ul class="share-icon-box">
        <li
          class="share-item"
          v-for="item in shareList"
          :key="item.key"
          @click="toShare(item.key)"
        >
          <img class="share-icon" :src="item.img" alt="" />
          <p>{{ item.name }}</p>
        </li>
      </ul>
      <div class="tool-popup-btn" @click="sharePopup = false">取消</div>
    </van-popup>
  </div>
</template>

<script>
import Mshare from "m-share";

import Hoarding from "@/views/mobileView/detail/components/Hoarding.vue";
import { Toast } from "vant";
var vm;
export default {
  components: {
    Hoarding,
  },
  props: ["title", "artSummary", "cover", "shareInfo"],
  data() {
    return {
      sharePopup: false,
      showPoster: false,
      shareList: [
        {
          key: "wx",
          name: "微信",
          img: require("@/assets/img/mobile-img/wx.png"),
        },
        {
          key: "pyq",
          name: "朋友圈",
          img: require("@/assets/img/mobile-img/pxq.png"),
        },
        {
          key: "qq",
          name: "QQ",
          img: require("@/assets/img/mobile-img/qq.png"),
        },
        {
          key: "qqkj",
          name: "QQ空间",
          img: require("@/assets/img/mobile-img/qqkj.png"),
        },
        {
          key: "wb",
          name: "新浪微博",
          img: require("@/assets/img/mobile-img/wb.png"),
        },
        {
          key: "link",
          name: "复制链接",
          img: require("@/assets/img/mobile-img/copy-link.png"),
        },
      ],
      shareImg: {
        key: "img",
        name: "名片分享",
        img: require("@/assets/img/mobile-img/share-img.png"),
      },
      saveImg: {
        key: "save-img",
        name: "保存图片",
        img: require("@/assets/img/mobile-img/save-img.png"),
      },
      MshareInfo: {
        title: "",
        desc: "",
        link: "",
        imgUrl: "",
      },
    };
  },
  watch: {
    shareInfo: {
      handler(newV) {
        this.MshareInfo = {
          title: this.$global.matchReg(newV.title) + " - 中文知识网",
          desc: newV.artSummary ? this.$global.matchReg(newV.artSummary) : "",
          link: window.location.href,
          imgUrl: newV.cover ? `${this.$global.imgUrl}${newV.cover}` : "",
        };
        Mshare.init(this.MshareInfo);
      },
      deep: true,
    },
  },
  async created() {
    vm = this;
    // 图书  会议  课程 增加图片分享  百家号  百科号  机构号详情页增加名片分享 -》 生成海报
    if (["图书", "会议", "课程"].indexOf(this.title) != -1) {
      this.shareImg.name = "图片分享";
      this.shareList.unshift(this.shareImg);
    } else if (["百家号", "百科号", "机构号"].indexOf(this.title) != -1) {
      this.shareImg.name = "名片分享";
      this.shareList.unshift(this.shareImg);
    }

    vm.$bus.$on("pageNavStatus", (status) => {
      console.log("pageNavStatus", status);
    });
  },
  methods: {
    // 打开分享弹窗
    openShare() {
      if (this.$route.query.out) {
        let Url = this.eliminate();
        let appShareInfo = {
          ...this.shareInfo,
          isCollect: sessionStorage.getItem("isCollect"),
          pageUrl: Url + "share=false",
          shareBox: "bottom",
        };
        console.log(appShareInfo, "appShareInfo");
        const shareJson = JSON.stringify(appShareInfo);
        if (this.$global.isAndroid_ios()) {
          window.android.sharing(shareJson);
        } else {
          window.webkit.messageHandlers.sharing.postMessage(shareJson); //ios
        }
      } else {
        this.sharePopup = true;
      }
    },
    // 分享 复制链接剔除特殊字段
    eliminate() {
      let url = document.location.toString();
      let urlArr = url.split("?");
      let baseUrl = urlArr[0] + "?";
      let params = Object.create(null);
      if (urlArr.length > 1) {
        urlArr = urlArr[1].split("&");
        urlArr.forEach((item) => {
          item = item.split("=");
          if (
            item[0] === "out" ||
            item[0] === "app" ||
            item[0] === "share" ||
            item[0] === "token"
          ) {
            return;
          }
          {
            params[item[0]] = item[1];
          }
        });
      }
      for (const key in params) {
        baseUrl = baseUrl + [key] + "=" + params[key] + "&";
      }
      return baseUrl;
    },
    toShare(type) {
      switch (type) {
        case "wx":
          Mshare.to("wx", this.MshareInfo);
          break;
        case "pyq":
          Mshare.to("wxline", this.MshareInfo);
          break;
        case "qq":
          Mshare.to("qq", this.MshareInfo);
          break;
        case "qqkj":
          Mshare.to("qzone", this.MshareInfo);
          break;
        case "wb":
          Mshare.to("sina", this.MshareInfo);
          break;
        case "link":
          const input = document.createElement("input");
          input.setAttribute("readonly", "readonly");
          let url = window.location.href; // 复制到粘贴板
          input.setAttribute("value", url);
          document.body.appendChild(input);
          input.select();
          if (document.execCommand("copy")) {
            document.execCommand("copy");
            Toast("链接已复制");
          }
          document.body.removeChild(input);
          break;
        case "img":
          // this.drawPoster();
          this.sharePopup = false;
          this.showPoster = true;

          this.$bus.$emit("posterVisibleStatus", this.showPoster);
          this.$emit("sharePoster", this.showPoster);
          break;
      }
    },

    // getWxConfig() {
    //   axios
    //     .post(
    //       `/apis/zw-wechat/wx/nf/getSignature`,
    //       { url: location.href },
    //       {
    //         headers: {
    //           rsa: "no",
    //           "Content-Type": "application/json",
    //         },
    //       }
    //     )
    //     .then((response) => {
    //       Mshare.wxConfig({
    //         title: this.$global.matchReg(this.title) + " - 中文知识网",
    //         desc: this.$global.matchReg(this.artSummary),
    //         imgUrl: window.location.href,
    //         link: this.cover ? `${this.$global.imgUrl}${this.cover}` : "",
    //         wx: {
    //           debug: true,
    //           appId: response.data.data.appId,
    //           timestamp: response.data.data.timestamp,
    //           nonceStr: response.data.data.nonceStr,
    //           signature: response.data.data.signature,
    //         },
    //         infoMap: {
    //           wx: {
    //             title: this.$global.matchReg(this.title) + " - 中文知识网",
    //             desc: this.$global.matchReg(this.artSummary),
    //             imgUrl: window.location.href,
    //             link: this.cover ? `${this.$global.imgUrl}${this.cover}` : "",
    //           },
    //         },
    //       });
    //     });
    // },
  },
  beforeDestroy() {
    sessionStorage.removeItem("isCollect");
  },
};
</script>

<style lang="scss" scoped>
.tool-box {
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: calc(constant(safe-area-inset-bottom) + 49px);
  height: calc(env(safe-area-inset-bottom) + 49px);
  background: #ffffff;
  // padding-top: 20px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);

  .tool-icon-box {
    display: flex;
    align-items: center;
    font-size: 15px;
    font-weight: 400;
    color: #333333;
    line-height: 21px;

    .tool-icon {
      margin-right: 10px;
      width: 19px;
      height: 19px;
    }
  }
  button {
    width: 100px;
    height: 42px;
  }
}

// 分享面板
.tool-popup {
  background-color: #f5f5f5;

  .share-icon-box {
    padding: 20px 12px 70px;
    white-space: nowrap;
    overflow-x: auto;

    .share-item {
      display: inline-block;
      margin: 0 12px;
      // width: 44px;
      text-align: center;

      .share-icon {
        width: 44px;
        height: 44px;
      }
    }
  }

  // 分享面板中分享按钮
  .tool-popup-btn {
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 15px 0;
    width: 100%;
    background-color: #fff;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    color: #333333;
    line-height: 21px;
  }
}

//
</style>
